<template>
  <div class="tourist-news">
    <Title :title="newsTitle" :english-title="newsEnglishTitle"></Title>
    <div class="section-content">
      <NewsList :serve-url="serveUrl" :request="request" tabs open-api @newsDetails="newsDetails" @change="tabChange"></NewsList>
    </div>
    <SeeMore :next="newsNext" :name="name"></SeeMore>
  </div>
</template>
<script>
import Title from "../components/Title";
import SeeMore from "../components/SeeMore";
import { mapGetters } from "vuex";

export default {
  name: "NewList",
  data() {
    return {
      newsTitle: "校园要闻",
      newsEnglishTitle: "campus news",
      newsNext: { next: "NewsCenter", data: {} },
      name:'全部资讯'
    };
  },
  components: {
    Title,
    SeeMore
  },
  computed: {
    ...mapGetters(["serveUrl", "request"])
  },
  methods: {
    newsDetails(data) {
      const { href } = this.$router.resolve({
        name: "NewsDetail",
        query: {
          id: data.id
        }
      });
      window.open(href);
      // const { href } = this.$router.resolve({
      //   name: "NewsDetail",
      //   query: {
      //     newsId: data.id
      //   }
      // });
      // window.open(href, "_blank");
    },
    tabChange(data) {
      this.newsNext.data = data;
    }
  }
};
</script>
<style lang="scss">
@import "@/styles/variables.scss";

.tourist-news {
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.98);

  .components-title {
    padding-top: 90px;
    padding-bottom: 50px;
  }

  .see-more {
    margin-top: 40px;
    margin-bottom: 50px;
    color: $color-primary;
    border: 1px solid $color-primary;
  }
}
</style>
